var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tree',{ref:"tree",attrs:{"data":_vm.data,"mode":_vm.mode,"role":_vm.role},on:{"item-click":_vm.onClickNode,"item-drag-start":_vm.onDragStart,"item-drag-end":_vm.onDragEnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }